// Durações de animação em milissegundos
export const ANIMATION_DURATIONS = {
  // Tempo base - usado para TODAS as animações e delays
  BASE: 650,

  // Tempo mínimo de exibição de cada texto no GlobalProgress
  MIN_TEXT_DISPLAY: 1000,

  // Delay para aguardar React/browser completarem renderização
  RENDER_DELAY: 300,
};

// Tempos calculados (para facilitar manutenção)
export const CALCULATED_DURATIONS = {
  // Tempo total de navegação entre páginas (fadeOut + delay + fadeIn)
  PAGE_TRANSITION_TOTAL: ANIMATION_DURATIONS.BASE * 3, // 1950ms

  // Delay + animação para fadeIn após loading
  FADEIN_AFTER_DELAY: ANIMATION_DURATIONS.BASE * 2, // 1300ms
};

// Dimensões e margens
export const SDK_HEIGHT_MARGIN = 30; // Margem em pixels para altura do SDK (100vh - 30px)
export const SDK_HEIGHT = `calc(100vh - ${SDK_HEIGHT_MARGIN}px)`;
